import { ReactElement, useEffect } from 'react';

import Box from '@mui/material/Box';

import ApplicationRequestDirectory from '../components/applicationRequests/ApplicationRequestDirectory';
import GratiPageWrapper from '../components/common/GratiPageWrapper';
import { useApp } from '../contextProviders/AppProvider';
import useApplicationRequests from '../dataHooks/useApplicationRequests';

export default function ApplicationRequestsPage(): ReactElement {
  const { setPageName } = useApp();
  const { applicationRequests, isApplicationRequestsLoading, applicationRequestsError } = useApplicationRequests();

  useEffect(() => {
    setPageName('Application Requests');
  }, [setPageName]);

  return (
    <GratiPageWrapper>
      <Box sx={{ width: '100%' }}>
        <ApplicationRequestDirectory
          pageTitle="Application Requests"
          applicationRequests={applicationRequests || undefined}
          isLoading={isApplicationRequestsLoading}
          error={applicationRequestsError}
        />
      </Box>
    </GratiPageWrapper>
  );
}
